

import themeMain from "../directives/themeMain";

/**
 * You can register global directives here and use them as a plugin in your main Vue instance
 */

const GlobalDirectives = {
  install(Vue) {
    Vue.directive("themeMain", themeMain);
  }
};

export default GlobalDirectives;



// WEBPACK FOOTER //
// ./src/plugins/globalDirectives.js